/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass
 */
export interface FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass
     */
    GameAccountName: string;
}

/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass(value: object): value is FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass {
    if (!('GameAccountName' in value) || value['GameAccountName'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass {
    return FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass {
    if (json == null) {
        return json;
    }
    return {
        
        'GameAccountName': json['GameAccountName'],
    };
}

export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSON(json: any): FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass {
    return FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'GameAccountName': value['GameAccountName'],
    };
}

